<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>学导跟进数据</Breadcrumb-item>
      </Breadcrumb>
      <div style="font-size: small">
        【外教课耗:】<span style="color: red">{{details.totalRoutineNum}}</span>
        【中教课耗:】<span style="color: red">{{details.totalChineseNum}}</span>
        【陪练课耗:】<span style="color: red">{{details.totalPartnerNum}}</span>
        【辅修课耗:】<span style="color: red">{{details.totalMinorNum}}</span>
        <!-- 【外教补课数量:】<span style="color: red">{{details.totalMakeupNum}}</span>
        【中教补课数量:】<span style="color: red">{{details.totalChineseMakeupNum}}</span> -->
        【试听课数:】<span style="color: red">{{details.totalAuditionNum}}</span>
      </div>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :span="6">
          <Form-item label="上课时间">
            <Row>
              <Col span="11">
              <Date-picker type="datetime" v-model="startTimeStr" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="startTimeDateChange" style="width: 100%;"></Date-picker>
              </Col>
              <Col span="2" style="text-align: center">
              -</Col>
              <Col span="11">
              <Date-picker type="datetime" v-model="endTimeStr" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="endTimeDateChange" style="width: 100%;"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="学导：">
            <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.adminUserId"></admin-user-select>
          </Form-item>
          </Col>
          <Col :span="6">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search">搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" listUrl="/adminUser/listStudyAdviserData"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>

</template>
<script>
  import dates from '@/tools/date/dates.js'
  export default {
    data () {
      return {
        searchLoading: false,
        showLessonCountModal: false,
        url: null,
        courseType: '',
        startTimeStr: '',
        endTimeStr: '',
        details: '',
        queryParams: {
          studyAdviserId: null,
        },
        queryParam: {
          startTimeSec: '',
          endTimeSec: '',
          status: 1,
          adminUserId: '',
        },
        title: [
          {
            title: 'ID',
            // width: 80,
            align: 'center',
            key: 'studyAdviserId'
          },
          {
            title: '名字',
            // width: 130,
            align: 'center',
            key: 'studyAdviserName'
          },
          {
            title: '课耗 外教/中教/陪练/辅修',
            // width: 140,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('div',
                [
                  h('a', {on: {click: () => this.showDetail(params, 'routine')}}, row.routineNum + ' / '),
                  h('a', {on: {click: () => this.showDetail(params, 'chinese')}}, row.chineseNum + ' / '),
                  h('a', {on: {click: () => this.showDetail(params, 'partner')}}, row.partnerNum + ' / '),
                  h('a', {on: {click: () => this.showDetail(params, 'minor')}}, row.minorNum),
                ])
            }
          },
          /* {
            title: '补课数量 外教/中教/陪练',
            width: 140,
            render: (h, params) => {
              let row = params.row
              return h('div',
                [
                  h('a', {on: {click: () => this.showDetail(params, 'makeup')}}, row.makeupNum + ' / '),
                  h('a', {on: {click: () => this.showDetail(params, 'chineseMakeup')}}, row.chineseMakeupNum + ' / '),
                  h('a', {on: {click: () => this.showDetail(params, 'partner')}}, row.partnerNum),
                ])
            }
          }, */
          {
            title: '试听课数',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.showDetail(params, 'audition')}}, row.auditionNum)
            }
          },
          {
            title: '工单 完成/未完成',
            // width: 150,
            align: 'center',
            render (h, params) {
              let row = params.row
              return h('span', row.processed + ' / ' + row.unprocessed)
            }
          },
          {
            title: '学生请假总数量',
            // width: 140,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.showTotalLeaveDetail(row.studyAdviserId)}}, row.totalLeaveNum)
            }
          },
          {
            title: '补偿请假数',
            key: 'leaveNum',
            // width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.showLeaveDetail(row.studyAdviserId)}}, row.leaveNum)
            }
          },
          {
            title: '补偿课时',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.showAddCourseDetail(row.studyAdviserId)}}, row.addLessonNum)
            }
          },
          {
            title: '电话回访次数',
            // width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.showTelDetails(row.studyAdviserId)}}, row.callNum)
            }
          },
          {
            title: '回访时间(分钟)',
            key: 'totalCallTime',
            // width: 140,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', (row.totalCallTime).toFixed(2))
            }
          },
          {
            title: '学员数',
            // width: 100,
            align: 'center',
            key: 'bindStuNum'
          }
        ]
      }
    },
    methods: {
      showTelDetails (studyAdviserId) {
        localStorage.setItem('studyAdviserId', studyAdviserId)
        localStorage.setItem('startTime', this.queryParam.startTimeSec)
        localStorage.setItem('endTime', this.queryParam.endTimeSec)
        this.$router.push({path: '/data/telDetails'})
      },
      showTotalLeaveDetail (studyAdviserId) {
        localStorage.setItem('studyAdviserId', studyAdviserId)
        localStorage.setItem('startTime', this.queryParam.startTimeSec)
        localStorage.setItem('endTime', this.queryParam.endTimeSec)
        this.$router.push({path: '/data/showTotalLeaveDetail'})
      },
      showAddCourseDetail (studyAdviserId) {
        localStorage.setItem('studyAdviserId', studyAdviserId)
        localStorage.setItem('startTime', this.queryParam.startTimeSec)
        localStorage.setItem('endTime', this.queryParam.endTimeSec)
        this.$router.push({path: '/data/showAddCourseDetail'})
      },
      showLeaveDetail (studyAdviserId) {
        localStorage.setItem('studyAdviserId', studyAdviserId)
        localStorage.setItem('startTime', this.queryParam.startTimeSec)
        localStorage.setItem('endTime', this.queryParam.endTimeSec)
        this.$router.push({path: '/data/showAddLeaveNumDetail'})
      },
      startTimeDateChange (value) {
        if (value) {
          this.queryParam.startTimeSec = (Date.parse(new Date(value)) / 1000) - 28800
        } else {
          this.queryParam.startTimeSec = null
        }
      },
      endTimeDateChange (value) {
        if (value) {
          this.queryParam.endTimeSec = (Date.parse(new Date(value)) / 1000) + 57599
        } else {
          this.queryParam.endTimeSec = null
        }
      },
      showDetail (params, cmd) {
        localStorage.setItem('startTime', this.queryParam.startTimeSec)
        localStorage.setItem('endTime', this.queryParam.endTimeSec)
        localStorage.setItem('studyAdviserId', params.row.studyAdviserId)
        if (cmd === 'routine') {
          localStorage.setItem('courseType', 1)
        }
        if (cmd === 'chinese') {
          localStorage.setItem('courseType', 2)
        }
        if (cmd === 'living') {
          localStorage.setItem('courseType', 3)
        }
        if (cmd === 'minor') {
          localStorage.setItem('courseType', 4)
        }
        if (cmd === 'chineseMakeup') {
          localStorage.setItem('courseType', 6)
        }
        if (cmd === 'makeup') {
          localStorage.setItem('courseType', 5)
        }
        if (cmd === 'partner') {
          localStorage.setItem('courseType', 8)
        }
        if (cmd === 'audition') {
          localStorage.setItem('lsnType', 1)
        }
        this.$router.push({path: '/data/showLessonCount'})
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      search () {
        this.$refs.dataList.search()
        let self = this
        // self.queryParam.startTimeSec = Date.parse(self.startTimeStr) / 1000
        // self.queryParam.endTimeSec = Date.parse(self.endTimeStr) / 1000
        self.$http.post('/adminUser/getTotalStudyAdviserData', self.queryParam).then(function (res) {
          self.details = res.data
        })
        // self.reload = new Date().getMilliseconds()
      },
    },
    mounted: function () {
      let self = this
      this.$http.post('/adminUser/getTotalStudyAdviserData', self.queryParam).then(function (res) {
        self.details = res.data
      })
    },
    created: function () {
      this.startTimeStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '1'
      this.endTimeStr = dates.format(Date.now(), 'YYYY-MM-DD')
      this.queryParam.startTimeSec = Date.parse(this.startTimeStr) / 1000
      this.queryParam.endTimeSec = Date.parse(this.endTimeStr) / 1000
    }
  }
</script>



// WEBPACK FOOTER //
// StudyAdviserTrack.vue?71d29fed